// extracted by mini-css-extract-plugin
module.exports = {"project-stat-pie-chart":"styles_project-stat-pie-chart__2YW-a","projectStatPieChart":"styles_project-stat-pie-chart__2YW-a","title":"styles_title__1JkD1"};